export default __webpack_public_path__ + "static/media/client3.23d7a0ee.png";